import { MyCartAction_PlaceOrder } from "../../../../../domain/cart/types";
import { CheckoutPaymentMethodSelectionState } from "./payment-methods";

export function toPlaceOrderPaymentMethodData(
  pm: NonNullable<CheckoutPaymentMethodSelectionState>,
): MyCartAction_PlaceOrder["payment"] {
  switch (pm.tag) {
    case "credit-card": {
      return {
        tag: "credit-card" as const,
        card: pm.encryptedCartData,
        brandName: pm.brand.brand,
      };
    }

    case "paypal": {
      return {
        tag: "paypal" as const,
      };
    }

    case "klarna_paynow": {
      return {
        tag: "klarna_paynow" as const,
      };
    }

    case "klarna": {
      return {
        tag: "klarna" as const,
      };
    }

    case "klarna_account": {
      return {
        tag: "klarna_account" as const,
      };
    }

    case "googlepay": {
      return {
        tag: "googlepay" as const,
        data: pm.data,
      };
    }

    case "applepay": {
      return {
        tag: "applepay" as const,
        data: pm.data,
      };
    }

    case "eps": {
      return {
        tag: "eps",
        data: {
          id: pm.data.id,
        },
      };
    }

    case "directEbanking": {
      return {
        tag: "directEbanking",
      };
    }

    case "swish": {
      return {
        tag: "swish",
      };
    }

    case "ideal": {
      return {
        tag: "ideal",
      };
    }

    case "vipps": {
      return {
        tag: "vipps",
      };
    }

    default: {
      const _: never = pm;

      return _;
    }
  }
}
